import { MyNavbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { About } from "../components/About";

export function AboutUs() {
  return (
    <main>
      <MyNavbar />
      <About />
      <Footer />
    </main>

  );
}
